import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import { ListGroup, Container, Row, Col, Modal, Button, Nav } from 'react-bootstrap';
import { Link } from "react-router-dom";

import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';

//import { slugify } from 'utils/Helper';

//import { useForm } from 'react-hubspot'

import { assembleNickname } from "utils/Helper.js";
// , get_current_unix_stamp
//import { makeCall } from "components/VideoChat/VideoChatControl";

import './style.css';

function TipHistoryModal (props) {
  //console.log("OnboardingModal constructor",props);
  
  const user_context = useContext(UserContext);

  const [tab_choice, setTabChoice] = useState(props.tab_choice || 'users.audience');

  //const [step_name, setStepName] = useState('');
  const [loading, setLoading] = useState(true);
  const [tip_entities, setTipEntities] = useState([]);
  
  const [message, setMessage] = useState(<React.Fragment></React.Fragment>);

  const tab_info = {
    'users.audience': {
      title: "My Tips to Other Creators",
    },
    'audience': {
      title: "Tips Given to Me",
    },
  };

  /*
  async function onUnFollow (selected_entity) {
    console.log("onUnFollow",selected_entity);
    
    // first remove from state
    let tmp_followed_entities = followed_entities.filter( element => element.entity_uuid !== selected_entity.entity_uuid );
    setFollowedEntities(tmp_followed_entities);
    
    let patch_obj = {
      [tab_choice+'.audience']: [
        {
          entity_uuid: selected_entity.entity_uuid,
          xref_data: {
            favorited_time: -1
          }
        }
      ]
    };
    
    await axios.patch(`${apiUrl}users/${user_context.user_info.entity_uuid}`,patch_obj);
    
  }
  */

  async function setupEntities (tmp_tab_choice = tab_choice) {
    
    if (tmp_tab_choice === 'audience' && user_context.user_info.account_level !== 'private' && user_context.user_info.access_level !== 'admin') {
      return;
    }
    
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);

    let params = {
      filter_obj: {
        tips: {
          exists: true
        },
      }
    };

    let tip_entities_response = await axios.get(`${apiUrl}users/${user_context.user_info.entity_uuid}/${tmp_tab_choice}`, { params, ...myHeaders_Auth_With_Cache_Control });

    // assemble tips array per tip
    let tmp_tips = [];
    
    tip_entities_response.data.forEach( user_element => {
      if (user_element.xref_data && user_element.xref_data.tips)
      user_element.xref_data.tips.forEach( tip_element => {
        let tip_obj = {
          entity_name: assembleNickname(user_element),
          tip_amount: tip_element.tip_amount,
          tip_time: tip_element.tip_time,
          friendly_url: user_element.friendly_url,
          status_code: user_element.status_code
        };  
        tmp_tips.push(tip_obj);
      });
    });
    
    // put tips into date order descending
    tmp_tips = tmp_tips.sort((a,b) => a.tip_time < b.tip_time ? 1 : -1);

    console.log("tmp_tips",tmp_tips);
    setTipEntities(tmp_tips);

    setMessage(<span>&nbsp;</span>);
    setLoading(false);
  }

  function changeTab (eventKey) {
    console.log("changeTab",eventKey,tab_choice);
    if (eventKey !== tab_choice) {
      setTipEntities([]);
      setMessage(<span>&nbsp;</span>);
      setTabChoice(eventKey);
      setupEntities(eventKey);
    }
    
  }

  // on mount
  useEffect(() => {
    console.log("TipHistoryModal useEffect props.show");

    if (!user_context.user_info || !user_context.user_info.entity_uuid) {
      return;
    }
    
    setupEntities();
    
  }, [props.show,user_context]);
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          My Tip History<br/>
          { (user_context.user_info.account_level !== 'private' && user_context.user_info.access_level !== 'admin') &&
            <a style={{ color: "#16a085" }} target="_blank" href={local_routes.pricing}>Want to get tipped for your creative genius? Click here to find out more about PK Create PRO</a>
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ height: "400px" }}>
          <Row style={{ paddingBottom: "10px" }}>
            <Col>
              <Nav justify variant="tabs" activeKey={tab_choice} onSelect={(k) => changeTab(k)}>
                {
                  Object.keys(tab_info).map( tab_name => {
                    return (
                      <Nav.Item key={tab_name}>
                        <Nav.Link eventKey={tab_name}>{tab_info[tab_name].title}</Nav.Link>
                      </Nav.Item>
                    );
                  })
                }
              </Nav>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup variant="flush">
                {
                  tip_entities.map( (element,index) => {
                    return (
                      <ListGroup.Item key={index}>
                        { (element.friendly_url && element.status_code === 1) ?
                          <Link target="_blank" to={'/users/'+element.friendly_url}>{element.entity_name}</Link>
                          :
                          <span>{element.entity_name}</span>
                        }
                        <span className="float-right">
                          {new Date(element.tip_time * 1000).toLocaleString()}
                        </span>
                        <span className="float-right" style={{ marginRight: '10px' }}>
                          {(element.tip_amount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"})}
                        </span>
                      </ListGroup.Item>
                    );
                  })
                }
              </ListGroup>
            </Col>
          </Row>
          
        </Container>
      </Modal.Body>
      {/*
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>Done</Button>
      </Modal.Footer>
      */}
    </Modal>
  );
}

function TipHistoryModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  console.log("TipHistoryButton",props);

  let button_icon = '';
  let button_text = 'Tip History';
  //if (props.event_entity_name) {
  //  button_text = props.event_entity_name;
  //}
  let button_tooltip = 'Click to see who has tipped you, and who you have tipped!';

  return (
    <React.Fragment>
      <Button variant="pkprimary" onClick={() => setModalShow(true)}>
        {button_icon}{button_text}
      </Button>

      <TipHistoryModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        tab_choice={props.tab_choice}
      />
      <ReactTooltip />
    </React.Fragment>
  );
}

export default TipHistoryModalButton;